import React from 'react';

const GestaoAVistaContext = React.createContext();

export default GestaoAVistaContext;
